import { IntlContextWithDictionary } from '../types';
import { Fragment, FunctionalComponent, h } from 'preact';
import { IntlContext } from 'preact-i18n';
import { useContext } from 'preact/hooks';
import { DASH, Price, Properties } from '../../common';
import { formatPrice, PriceFormatOptions } from './priceFormatUtils';

export interface PriceFormatProps extends Properties {
  price: Price;
  options: PriceFormatOptions;
}

export const PriceFormat: FunctionalComponent<PriceFormatProps> = ({
  price,
  options,
}: PriceFormatProps): h.JSX.Element => {
  const context: IntlContextWithDictionary = useContext(IntlContext);
  return <Fragment>{formatPrice(price, options, context) || options.placeholder || DASH}</Fragment>;
};
